<woa-modal-page-layout [title]="title()"
                       [customGeometry]="responsiveService.mobile() ? undefined : {
                           pillarboxedOnDesktop: 'none',
                           width: '800px',
                           height: '500px'
                       }">
    @if (showStoreOrderTypeOptions()) {
        <div class="store-details-header" woa-responsive slot="header">
            @if (orderAheadStoreOption() && orderType() !== OrderType.ORDER_AHEAD) {
                <woa-link [link]="'woa.button.ordering-context.show-store-details.orderAhead'"
                          (onActivate)="changeOrderType(OrderType.ORDER_AHEAD)"></woa-link>
            }
            @if (orderDeliveryStoreOption() && orderType() !== OrderType.ORDER_DELIVERY) {
                <woa-link [link]="'woa.button.ordering-context.show-store-details.delivery'"
                          (onActivate)="changeOrderType(OrderType.ORDER_DELIVERY)"></woa-link>
            }
            @if (orderAtTableStoreOption() && orderType() !== OrderType.ORDER_AT_TABLE) {
                <woa-link [link]="'woa.button.ordering-context.show-store-details.orderAtTable'"
                          (onActivate)="changeOrderType(OrderType.ORDER_AT_TABLE)"></woa-link>
            }
        </div>
    }
    <woa-store-details-panel [store]="store()"
                             [intention]="intention()"
                             [filteredOrderType]="orderingContext().selectedOrderType"
                             [showStoreImage]="false"
                             [showMoreDetails]="false"
                             [showTelephone]="true"
                             [showMap]="true"
                             (onOrderFromStore)="orderFromStore($event)"></woa-store-details-panel>
</woa-modal-page-layout>
